import React from 'react';
import Select from 'react-select';
import { Link } from 'react-router-dom';

const PersonalRelationsCard = ({
    isEditRelations,
    setIsEditRelations,
    updateCandidateRelations,
    onAddRelationContents,
    relations,
    userLoginInfo,
    RELATION_TYPES,
    onChangeRelationContentInput,
    onDeleteRelationContents
}) => {
    return (
        <div className='card card-default'>
            <div className='card-header'>
                <h3 className='card-title text-bold'>Personal Relations</h3>
                <div className='card-tools'>
                    {isEditRelations &&
                        <>
                            <button type='button'
                                    className='btn btn-default mr-3'
                                    onClick={() => {
                                        setIsEditRelations(false);
                                    }}
                            >
                                Cancel
                            </button>
                            <button type='button'
                                    className='btn btn-info mr-3'
                                    onClick={() => {
                                        updateCandidateRelations();
                                    }}
                            >
                                Save
                            </button>
                            <button className='btn btn-primary' type={'button'}
                                    onClick={(event) => onAddRelationContents(event)}>
                                <i className='fas fa-plus'/> Thêm
                            </button>
                        </>
                    }
                    {!isEditRelations &&
                        <button type='button'
                                className='btn btn-default'
                                onClick={() => {
                                    setIsEditRelations(true);
                                }}
                        >
                            Edit
                        </button>
                    }
                </div>
            </div>
            <div className='card-body table-responsive p-0 w-100'>
                <table
                    className='table table-hover table-bordered text-nowrap'
                    style={{
                        maxHeight: '80vh',
                        overflow: 'scroll',
                        minHeight: 300
                    }}
                >
                    <thead>
                    <tr>
                        <th>STT</th>
                        <th>Personal ID</th>
                        <th>Họ & Tên</th>
                        <th>Displayed Company</th>
                        <th>Displayed Title</th>
                        <th>Loại quan hệ</th>
                        <th>Mức độ quan hệ</th>
                        <th>Comment về Person</th>
                        <th>Job Refered</th>
                        <th>Note time</th>
                        <th>Note</th>
                        <th>Hành động</th>
                    </tr>
                    </thead>
                    <tbody>
                    {relations && relations.length > 0 && relations.map((item, index) => (
                        <tr key={`relation_content_${index}`}>
                            <td className={userLoginInfo.id !== item.created_user ? "bg-success" : ""}
                                title={`Người input: ${item.user_input}; Ngày NL mới nhất: ${item.updated_date_time}`}>
                                {index + 1}
                            </td>
                            <td>
                                {isEditRelations &&
                                    <input type={'text'} className='form-control'
                                           value={item.personal_id}
                                           name={`relation_personal_id_${index}`}
                                           disabled={userLoginInfo.id !== item.created_user}
                                           onChange={event => onChangeRelationContentInput(event, index, 'personal_id')}/>
                                }
                                {!isEditRelations && item.personal_id &&
                                    <Link to={`/candidate/detail/${item.personal_id}`}
                                          target='_blank'
                                          rel='noopener noreferrer'>{item.personal_id}</Link>
                                }
                            </td>
                            <td>{item.full_name}</td>
                            <td>{item.displayed_company}</td>
                            <td>{item.displayed_title}</td>
                            <td>
                                <div style={{width: '100%'}}>
                                    <Select options={RELATION_TYPES} isMulti
                                            isDisabled={!isEditRelations || userLoginInfo.id !== item.created_user}
                                            value={item.relation_type}
                                            onChange={values => {
                                                onChangeRelationContentInput(values, index, 'relation_type');
                                            }}
                                    />
                                </div>
                            </td>
                            <td>
                                <select className='form-control'
                                        name={`relation_relation_level_${index}`}
                                        value={item.relation_level}
                                        disabled={!isEditRelations || userLoginInfo.id !== item.created_user}
                                        onChange={event => onChangeRelationContentInput(event, index, 'relation_level')}>
                                    <option value='N/A'>N/A</option>
                                    <option value='Thân'>Thân</option>
                                </select>
                            </td>
                            <td>
                                <textarea className='form-control'
                                          value={item.comment_about_person}
                                          name={`relation_comment_about_person_${index}`}
                                          disabled={!isEditRelations || userLoginInfo.id !== item.created_user}
                                          onChange={event => onChangeRelationContentInput(event, index, 'comment_about_person')}/>
                            </td>
                            <td>
                                {!isEditRelations && item.job_referred ?
                                    <a href={`/job/edit/${item.job_referred}`}
                                       target="_blank"
                                       rel="noreferrer"
                                       className={'text-primary font-weight-bold'}>{item.job_referred}</a> :
                                    <input type={'text'} className='form-control'
                                           value={item.job_referred}
                                           name={`relation_job_referred_${index}`}
                                           disabled={userLoginInfo.id !== item.created_user}
                                           onChange={event => onChangeRelationContentInput(event, index, 'job_referred')}/>
                                }
                            </td>
                            <td>
                                <textarea className='form-control'
                                          value={item.note_time}
                                          name={`relation_note_time_${index}`}
                                          disabled={!isEditRelations || userLoginInfo.id !== item.created_user}
                                          onChange={event => onChangeRelationContentInput(event, index, 'note_time')}/>
                            </td>
                            <td>
                                <textarea className='form-control'
                                          value={item.note}
                                          name={`relation_note_${index}`}
                                          disabled={!isEditRelations || userLoginInfo.id !== item.created_user}
                                          onChange={event => onChangeRelationContentInput(event, index, 'note')}/>
                            </td>
                            <td>
                                <button type={'button'} className='btn btn-danger btn-sm'
                                        disabled={!isEditRelations || userLoginInfo.id !== item.created_user}
                                        onClick={() => onDeleteRelationContents(index)}>
                                    Xóa
                                </button>
                            </td>
                        </tr>))
                    }
                    </tbody>
                </table>

            </div>
        </div>
    );
};

export default PersonalRelationsCard;


